import { gql } from '@apollo/client';
import _ from 'lodash';
import type {
  PostEmbedPath_PostFragment,
  PostPath_PostFragment,
} from '../../graphql/generated/graphqlTypes';
import entityPath from './entityPath';

const POST_PATH_POST_FRAGMENT = gql`
  fragment postPath_post on RootPostFields {
    id
    title
  }
`;

const getPostPath = (
  post: PostPath_PostFragment,
  prefix: 'embed' | 'posts',
) => {
  return `/${prefix}/${entityPath(post.title, post.id)}`;
};

const POST_EMBED_PATH_POST_FRAGMENT = gql`
  fragment postEmbedPath_post on RootPostFields {
    ...postPath_post
  }
  ${POST_PATH_POST_FRAGMENT}
`;
export function postEmbedPath(post: PostEmbedPath_PostFragment) {
  return getPostPath(post, 'embed');
}

postEmbedPath.fragments = {
  post: POST_EMBED_PATH_POST_FRAGMENT,
};

export const createPostPath = (
  params:
    | { type: 'template' }
    | { type?: 'post'; topicId?: string; templateId?: string } = {},
) => {
  const allowedParams: Record<string, string> = _.pickBy(
    _.pick(params, ['topicId', 'templateId', 'type']),
  );
  const queryString = new URLSearchParams(allowedParams).toString();
  const search = queryString && `?${queryString}`;

  return `/drafts/new${search}`;
};

const postPath = (post: PostPath_PostFragment, anchor?: string) => {
  const link = getPostPath(post, 'posts');
  return anchor ? `${link}#${anchor}` : link;
};

postPath.fragments = {
  post: POST_PATH_POST_FRAGMENT,
};

const PUBLIC_POST_PATH_POST_FRAGMENT = gql`
  fragment publicPostPath_post on RootPostFields {
    ...postPath_post
  }
  ${POST_PATH_POST_FRAGMENT}
`;

export const publicPostPath = (post: PostPath_PostFragment, anchor?: string) =>
  `/public${postPath(post, anchor)}`;

publicPostPath.fragments = {
  post: PUBLIC_POST_PATH_POST_FRAGMENT,
};

export default postPath;
